import React from 'react'
import myPhoto from "../../assets/formal.jpg"
import { FaUniversity } from "react-icons/fa";
import { FaSchool } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import "./styles.css"
const About = () => {
  return (
    <section id="about">
        <h5>Get to Know</h5>
        <h2>About Me</h2>

        <div className="container about__container">
        <p className='about__text'>I am Harshvardhan R, a 4th year B.Tech student at National Institute of Technology Karnataka , Surathkal graduating in 2022. I am doing my majors in the Department of Information Technology.
        I am highly passionate about exploring various opportunities to develop my personality and skill sets, that would assist me in growing as a compatible multi-skilled individual.
        My interests lie in the field of Web development, Blockchain Technology and App development.</p>

            {/* <div className="about__me"> */}
                {/* <div className="about__me-image">
                    <img src={myPhoto} alt="About" />
                </div> */}
            {/* </div> */}
            <div className="about__content">
                <div className="about__cards">
                    <article className='about__card'>
                        <FaUniversity className='about__icon'/>
                        <h5>National Institute of Technology Karnataka, Surathkal</h5>
                        B.Tech IT
                        8.48 CGPA
                    </article>
                    <article className='about__card'>
                        <VscFolderLibrary className='about__icon'/>
                        <h5>Karnataka Pre University Board</h5>
                        96.33%
                    </article>
                    <article className='about__card'>
                        <FaSchool className='about__icon'/>
                        <h5>ICSE 10th Std Bengaluru</h5>
                        97.5%
                    </article>
                    

                    {/* <a href="#contact" className='btn btn-primary'>Let's Talk</a> */}
                </div>
            </div>
        </div>


    </section>
  )
}

export default About
        {/* Software Engineer with a focus on building elegant, efficient and maintainable solutions */}


        // Hey there, I am currently in my final year, pursuing a Bachelor's degree at the National Institute Of Technology Karnataka, Surathkal. 